var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "product-info__price" }, [
    _vm._v(_vm._s(_vm._f("money")(_vm.price))),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }